(() => {
  'use strict';

  const SELECTORS = [
    '.aoctant-footer__menu-heading',
    '.aoctant-collection-breadcrumb__link--home',
    '.aoctant-footer__social-link',
  ].join(',');

  const MAX_OFFSET = 4;
  const PULL_STRENGTH = 0.68;

  const bind = (control) => {
    if (control.dataset.aoctantMagnetBound === 'true') return;

    const target = control.querySelector('.svg-wrapper, .icon, svg');
    if (!target) return;

    control.dataset.aoctantMagnetBound = 'true';
    if (!control.hasAttribute('data-magnet')) control.setAttribute('data-magnet', '4');

    let baseRect = null;

    const onEnter = () => {
      const prev = target.style.transform;
      target.style.transform = 'none';
      baseRect = control.getBoundingClientRect();
      target.style.transform = prev;
      target.style.transition = 'transform 80ms var(--ease-out-cubic)';
    };

    const onMove = (event) => {
      const rect = baseRect || control.getBoundingClientRect();
      const dx = event.clientX - rect.left - rect.width / 2;
      const dy = event.clientY - rect.top - rect.height / 2;
      const distance = Math.hypot(dx, dy) || 1;
      const radius = Math.max(rect.width, rect.height) / 2;
      const pull = Math.min(distance / radius, 1);

      const x = (dx / distance) * pull * MAX_OFFSET * PULL_STRENGTH;
      const y = (dy / distance) * pull * MAX_OFFSET * PULL_STRENGTH;

      target.style.transition = 'transform 80ms var(--ease-out-cubic)';
      target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
    };

    const onLeave = () => {
      baseRect = null;
      target.style.transition = 'transform 260ms var(--ease-out-cubic)';
      target.style.transform = 'translate(0px, 0px)';
    };

    control.addEventListener('pointerenter', onEnter);
    control.addEventListener('pointermove', onMove);
    control.addEventListener('pointerleave', onLeave);
  };

  const bindWithin = (root = document) => {
    if (root instanceof Element && root.matches(SELECTORS)) bind(root);
    root.querySelectorAll?.(SELECTORS).forEach(bind);
  };

  const start = () => {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    bindWithin();

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) bindWithin(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();